import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';



class ButtonTest extends React.Component {

    constructor(props) {
      super(props);
      this.state={flag: true}
    }

    componentWillReceiveProps(newProps)
    {
      debugger;
      console.log(newProps);
      if(newProps.button.buttonValue == 0 )
        this.setState={flag: false}

    }
    render() {
        return (<RaisedButton

                        secondary={this.state.flag}
                        onClick={()=>{
                          this.props.onClick(this.props.button.buttonName,this.props.button.buttonValue);
                          //common handling of the onclick event of this button type
                        }}
                        label={this.props.button.buttonName}></RaisedButton>
        );
    }
}



export default ButtonTest;





/** WEBPACK FOOTER **
 ** ./src/components/ButtonTest.js
 **/